import React from "react";

const TONE_CLASS = {
  blue: "cq-quick-status-dot--blue",
  yellow: "cq-quick-status-dot--yellow",
  green: "cq-quick-status-dot--green",
  red: "cq-quick-status-dot--red",
  neutral: "cq-quick-status-dot--neutral",
};

/**
 * Compact status dot per quick-status-dot-contract.
 * @param {object} props
 * @param {"blue"|"yellow"|"green"|"red"|"neutral"} props.statusTone
 * @param {string} props.statusKey
 * @param {string} props.label
 * @param {string} props.accessibleLabel
 * @param {"sm"|"md"} [props.size]
 * @param {string} [props.title]
 * @param {string} [props.testId]
 */
export function QuickStatusDot({
  statusTone = "neutral",
  statusKey,
  label,
  accessibleLabel,
  size = "sm",
  title,
  testId = "quick-status-dot",
}) {
  const toneClass = TONE_CLASS[statusTone] || TONE_CLASS.neutral;

  return (
    <span
      className={`cq-quick-status-dot cq-quick-status-dot--${size} ${toneClass}`}
      data-testid={testId}
      data-status-key={statusKey}
      title={title || label}
      aria-label={accessibleLabel || label}
      role="img"
    />
  );
}
